module.exports = __webpack_public_path__ + "static/img/home_reciprocity.aba7bdb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_icons/home_reciprocity.jpeg
// module id = WmIa
// module chunks = 4